import React from "react";
import { motion } from "framer-motion";
import { useMotion } from "../../../Logic/Functions/Hooks/useMotion";
import styles from "./Aboutus.module.css";
import { IntroAboutUsProps } from "@model/Aboutus.model";



const IntroAboutUs: React.FC<IntroAboutUsProps> = ({
  data,
  once = true,
  triggerAmount = 0.35,
}) => {
  const { slideFade, containerStagger } = useMotion();

  return (
    <section className={styles.introWrap} data-testid="intro-about">
      <motion.div
        className={styles.introGrid}
        variants={containerStagger(0.1)}
        initial="hidden"
        whileInView="show"
        viewport={{ once, amount: triggerAmount }}
      >
        <div className={styles.introLeft}>
          <motion.h1
            className={styles.introTitle}
            data-testid="intro-about-title"
            variants={slideFade("left", 0.02)}
          >
            {data.title}
          </motion.h1>

          {data.subtitle && (
            <motion.p
              className={styles.introSub}
              data-testid="intro-about-sub"
              variants={slideFade("right", 0.04)}
            >
              {data.subtitle}
            </motion.p>
          )}

          {data.pills?.length ? (
            <motion.ul
              className={styles.introPills}
              data-testid="intro-about-pills"
              variants={containerStagger(0.12)}
            >
              {data.pills.map((p, i) => (
                <motion.li
                  key={`${p.label}-${i}`}
                  className={styles.introPill}
                  variants={slideFade("up", 0.02 * i)}
                >
                  {p.icon && <span className={styles.introPillIcon}>{p.icon}</span>}
                  {p.label}
                </motion.li>
              ))}
            </motion.ul>
          ) : null}

        </div>
        <motion.div className={styles.introRight} variants={slideFade("up", 0.08)}>
          {data.imageSrc ? (
            <img
              src={data.imageSrc}
              alt={data.imageAlt}
              className={styles.introHeroImg}
              data-testid="intro-about-image"
            />
          ) : (
            <div className={styles.introHeroImgPlaceholder} aria-hidden />
          )}
        </motion.div>
      </motion.div>
    </section>
  );
};

export default IntroAboutUs;
